import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { useCases } from '../../data/content';

/** Section 7 — teaching formats the system supports. */
export function UseCasesSection() {
  return <section aria-labelledby="usecases-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-234" data-mp="12sjpugs8cft7">
      <div className="mx-auto max-w-5xl" data-id="element-235" data-mp="xvbdiwtrj5zv">
        <SectionHeading id="usecases-heading" title={<>
              Built for the Way Makeup Educators <Accent data-id="element-237" data-mp="1qj755n4h67ps">Actually Teach</Accent>
            </>} data-id="element-236" data-mp="xwcnsz2yfogj" />

        <ul className="mt-12 grid gap-x-12 border-t border-brand-charcoal/12 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-238" data-mp="1ql9z2i8r0kzs">
          {useCases.map(({
          icon: Icon,
          title,
          description
        }) => <li key={title} className="flex items-start gap-4 border-b border-brand-charcoal/12 py-6" data-id="element-239" data-mp="1gr9vwlx11ptp">
              <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-white text-brand-plum" data-id="element-240" data-mp="2eacpofld1o6f">
                <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden="true" data-id="element-241" data-mp="vcpcwtamg7fn" />
              </span>
              <div data-id="element-242" data-mp="10cliuy2vq8xu">
                <h3 className="font-display text-[1.35rem] font-bold leading-snug text-brand-charcoal" data-id="element-243" data-mp="10b0op9kh8s0i">{title}</h3>
                <p className="mt-1 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-244" data-mp="ln5tnmizybk9">{description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}